import {ComponentPropertiesPane} from '../components/NodePropertiesPane.jsx'
import LongText from '../../SidePanel/RightPanel/PropertiesControllerLongText.jsx'
import Select from '../../SidePanel/RightPanel/PropertiesControllerSelect.jsx'
import Text from '../../SidePanel/RightPanel/PropertiesControllerText.jsx'
import Analyse from '../components/PropertiesControllerAnalyse.jsx'
//import ButtonClone from './PropertiesPaneButtonClone.jsx'
import ButtonDesign from './PropertiesPaneButtonDesign.jsx'
import ButtonPreview from './PropertiesPaneButtonPreview.jsx'
import DemoType from './DemoType.mjs'
import Model from './ModelWf.mjs'

const PropertiesPaneUv = (props) => (
    <ComponentPropertiesPane
        buttons={
            <>
                <ButtonDesign />
                <ButtonPreview />
            </>
        }

        controllers={
            <>
                <Text prop="wfName" />
                <Text prop="wfUserCode" />

                <Select
                    options={DemoType}
                    prop="demoType"
                />

                <LongText prop="memo" />
            </>
        }

        Model={Model}

        snSuffix={
            <Analyse
                modes={[
                    'ChgReferenceSingle',
                    'Reference',
                    'ReferenceCall',
                    'IsrfReference',
                ]}
            />
        }

        {...props}
    />
)

export default PropertiesPaneUv
